<template>
  <div
    v-if="!$store.getters.isPc"
    class="sp-header"
    :class="{'sp-header--showBack': isShowBack, 'sp-header--open': $store.getters.isShowNav}"
  >
    <div class="c-btnBack" @click="backtoTop">
      <span class="c-btnBack__arrow"></span>
      <span class="c-btnBack__text">BACK</span>
    </div>

    <transition name="fade">
    <div
      v-show="!$store.getters.isShowNav"
      class="sp-header__trigger sp-header__trigger--open"
      @click="open"
    >
      <div>
        <span></span>
        <span></span>
      </div>
    </div>
    </transition>

    <transition name="fade">
    <div
      v-show="$store.getters.isShowNav"
      class="sp-header__trigger sp-header__trigger--close"
      @click="close"
    >
      <div>
        <span></span>
        <span></span>
      </div>
    </div>
    </transition>

    <transition name="fade">
    <div v-show="$store.getters.isShowNav" class="sp-header__wrap">
      <div>
        <ul class="sp-header__wrapNav">
          <li><div :class="{'is-active': state === 'top'}" @click="linkNav('/')">TOP</div></li>
          <li><div :class="{'is-active': state === 'works'}" @click="linkNav('/works/')">WORKS</div></li>
          <li><div :class="{'is-active': state === 'about'}" @click="linkNav('/about/')">ABOUT</div></li>
          <li><div :class="{'is-active': state === 'recruit'}" @click="linkNav('/recruit/')">RECRUIT</div></li>
        </ul>
        <ul class="sp-header__wrapSns">
          <li>
            <a class="c-iconFb" href="https://www.facebook.com/slantedtm" target="_blank" rel="noopener">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 51.97 96.12" width="51.97" height="96.12">
                <g>
                  <title>facebook</title>
                  <path d="M50,0,37.55,0c-14,0-23.06,9.28-23.06,23.66v10.9H2a2,2,0,0,0-2,2V52.33a2,2,0,0,0,2,2H14.49V94.16a2,2,0,0,0,2,2H32.8a2,2,0,0,0,2-2V54.29H49.42a2,2,0,0,0,2-2V36.52a1.94,1.94,0,0,0-.57-1.38,2,2,0,0,0-1.39-.58H34.76V25.32c0-4.45,1.06-6.7,6.85-6.7H50a2,2,0,0,0,2-2V2A2,2,0,0,0,50,0Z"/>
                </g>
              </svg>
            </a>
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.5 17.5" width="12.5" height="17.5">
              <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="none" d="M10.102,0.496 L10.880,0.945 L1.897,16.503 L1.119,16.54 L10.102,0.496 Z"/>
            </svg>
          </li>
          <li>
            <a class="c-iconTwitter" href="https://twitter.com/slanted_vfx" target="_blank" rel="noopener">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 416"><g id="Capa_1"><path d="M512,49.25c-19.04,8.35-39.33,13.89-60.48,16.58,21.76-12.99,38.37-33.41,46.18-58.02-20.29,12.1-42.69,20.64-66.56,25.41C411.87,12.7,384.42,0,354.46,0c-58.11,0-104.9,47.17-104.9,104.99,0,8.32,.7,16.32,2.43,23.94-87.26-4.26-164.48-46.08-216.35-109.79-9.06,15.71-14.37,33.7-14.37,53.06,0,36.35,18.72,68.58,46.62,87.23-16.86-.32-33.41-5.22-47.42-12.93v1.15c0,51.01,36.38,93.38,84.1,103.14-8.54,2.34-17.86,3.46-27.52,3.46-6.72,0-13.5-.38-19.87-1.79,13.6,41.57,52.19,72.13,98.08,73.12-35.71,27.94-81.06,44.77-130.14,44.77-8.61,0-16.86-.38-25.12-1.44,46.5,29.98,101.6,47.1,161.02,47.1,193.15,0,298.75-160,298.75-298.69,0-4.64-.16-9.12-.38-13.57,20.83-14.78,38.34-33.25,52.61-54.5Z"/></g></svg>
            </a>
          </li>
          <li>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.5 17.5" width="12.5" height="17.5">
              <path fill-rule="evenodd" stroke="rgb(255, 255, 255)" stroke-width="1px" stroke-linecap="butt" stroke-linejoin="miter" fill="none" d="M10.102,0.496 L10.880,0.945 L1.897,16.503 L1.119,16.54 L10.102,0.496 Z"/>
            </svg>
          </li>
          <li>
            <a class="c-iconInsta" href="https://www.instagram.com/slanted_vfx/" target="_blank" rel="noopener">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.06 169.06"><g id="Layer_1"><g><path d="M122.41,0H46.65C20.93,0,0,20.93,0,46.65V122.41c0,25.73,20.93,46.65,46.65,46.65H122.41c25.73,0,46.66-20.93,46.66-46.65V46.65c0-25.72-20.93-46.65-46.66-46.65Zm31.66,122.41c0,17.46-14.2,31.65-31.66,31.65H46.65c-17.45,0-31.65-14.2-31.65-31.65V46.65c0-17.45,14.2-31.65,31.65-31.65H122.41c17.45,0,31.66,14.2,31.66,31.65V122.41h0Z"/><path d="M84.53,40.97c-24.02,0-43.56,19.54-43.56,43.56s19.54,43.56,43.56,43.56,43.56-19.54,43.56-43.56-19.54-43.56-43.56-43.56Zm0,72.12c-15.75,0-28.56-12.81-28.56-28.56s12.81-28.56,28.56-28.56,28.56,12.81,28.56,28.56c0,15.75-12.81,28.56-28.56,28.56Z"/><path d="M129.92,28.25c-2.89,0-5.73,1.17-7.77,3.22-2.05,2.04-3.23,4.88-3.23,7.78s1.18,5.73,3.23,7.78c2.04,2.04,4.88,3.22,7.77,3.22s5.73-1.18,7.78-3.22c2.05-2.05,3.22-4.89,3.22-7.78s-1.17-5.74-3.22-7.78c-2.04-2.05-4.88-3.22-7.78-3.22Z"/></g></g></svg>
            </a>
          </li>         
        </ul>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
  import {breakpoint, assets_path} from '@/_constant/variables';
  import store from '@/_modules/stores';
  import {gsap, Quart, Cubic} from 'gsap';

  export default {
    data() {
      return {
        breakpoint: breakpoint,
        assets_path: assets_path,
        isShowBack: false,
        state: '',
      }
    },
    store,
    watch: {
      $route(to, from) {
        this.close();
        this.changeActive();
        this.changeBtn(to.name);
      }
    },
    computed: {
    },
    mounted() {
      this.changeActive();
      this.changeBtn(this.$route.name);
    },
    methods: {
      changeBtn(name) {
        if (name !== 'top' && name !== 'works') {
          this.isShowBack = true;
        } else {
          this.isShowBack = false;
        }
      },
      open() {
        if (this.$store.getters.isShowNav) {
          this.$store.commit('setShowNav', false);
        } else {
          this.$store.commit('setShowNav', true);
        }
      },
      close() {
        this.$store.commit('setShowNav', false);
      },
      backtoTop() {
        this.$router.push('/');
      },
      changeActive(name, isEnter) {
        if (name === 'scroll-works') {
          if (isEnter) {
            // MV見える
            this.state = 'top';
          } else {
            // MV見えなくなる
            this.state = 'works';
          }
        } else {
          this.state = this.$route.name;
        }
      },
      linkNav(path) {
        if (path === '/works/') {
          this.linkWorks();
        } else if (path === '/') {
          this.linkTop();
        } else {
          this.$router.push(path);
        }
      },
      linkTop() {
        this.close();
        if (this.$route.name !== 'top') {
          this.$router.push('/');
        }
        this.$nextTick(this.gotoTop);
      },
      gotoTop() {
        gsap.to(window, {
          duration: 0.7,
          scrollTo: {y: 0, autoKill: true},
          ease: Cubic.easeOut,
        });
      },
      linkWorks() {
        this.close();
        if (this.$route.name !== 'top') {
          this.$router.push('/');
        }
        this.$nextTick(this.gotoWorks);
      },
      gotoWorks() {
        let scrollY = 0;
        if (this.$store.getters.isPc) {
          //sp
          scrollY = window.innerHeight - 74;
        } else {
          //pc
          scrollY = window.innerHeight;
        }

        gsap.to(window, {
          duration: 0.7,
          scrollTo: {y: scrollY, autoKill: true},
          ease: Cubic.easeOut,
        });
      }
    }
  }
</script>
